<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateUser)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">Student Profile Detail - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h5 class="info-text">General Information</h5>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="address"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>directions</md-icon>
                  <label>Mother Name</label>
                  <md-input v-model="mother_name" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="address"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>directions</md-icon>
                  <label>Father Name</label>
                  <md-input v-model="father_name" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="birth_date"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="birth_date"
                  md-immediately
                >
                  <label>Birth Date</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="country_of_birth"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Country of birth</label>
                  <md-select v-model="country_of_birth" name="country_of_birth">
                    <md-option value="">Select Country</md-option>
                    <md-option
                      v-for="c in countries"
                      v-bind:key="c.id"
                      :value="c.id"
                      >{{ c.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="nationality"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>public</md-icon>
                  <label>Nationality</label>
                  <md-select v-model="nationality" name="nationality">
                    <md-option value="">Select Country</md-option>
                    <md-option
                      v-for="c in countries"
                      v-bind:key="c.id"
                      :value="c.id"
                      >{{ c.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="country_of_residence"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Country of residence</label>
                  <md-select
                    v-model="country_of_residence"
                    name="country_of_residence"
                  >
                    <md-option value="">Select Country</md-option>
                    <md-option
                      v-for="c in countries"
                      v-bind:key="c.id"
                      :value="c.id"
                      >{{ c.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="city_of_residence"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>City of residence</label>
                  <md-input v-model="city_of_residence" name="city" type="text">
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="whatsapp_number"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>perm_phone_msg</md-icon>
                  <label>Whatsapp number</label>
                  <md-input v-model="whatsapp_number" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100">
              <ValidationProvider
                name="address"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>directions</md-icon>
                  <label>Address (Max 300 character)</label>
                  <md-input v-model="address" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div
              class="md-layout-item md-size-100 md-small-size-100"
              v-if="agency"
            >
              <ValidationProvider
                name="agency"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>apartment</md-icon>
                  <label>Agency</label>
                  <md-input v-model="agency.name" disabled type="text">
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100">
              <h5 class="info-text">Passport Information</h5>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="passport_date_of_issue"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="passport_date_of_issue"
                  md-immediately
                >
                  <label>Passport date of issue</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="passport_number"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>layers</md-icon>
                  <label>Passport Number</label>
                  <md-input v-model="passport_number" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="passport_date_of_expire"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-datepicker
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  v-model="passport_date_of_expire"
                  md-immediately
                >
                  <label>Passport date of expire</label>
                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-datepicker>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <md-checkbox v-model="need_visa">Need visa?</md-checkbox>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Profile Detail</md-button
              >
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, confirmed, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  name: "edit-profile-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userID: null,
      mother_name: null,
      father_name: null,
      birth_date: null,
      country_of_birth: null,
      nationality: null,
      passport_number: null,
      passport_date_of_expire: null,
      passport_date_of_issue: null,
      country_of_residence: null,
      city_of_residence: null,
      address: null,
      whatsapp_number: null,
      need_visa: false,

      agency: null,
      countries: [],
      cities: []
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateUser() {
      this.$store
        .addUserInformation("PUT", this.userID, {
          mother_name: this.mother_name,
          father_name: this.father_name,
          birth_date: this.$store.format_date(this.birth_date),
          country_of_birth: this.country_of_birth,
          nationality: this.nationality,
          passport_number: this.passport_number,
          passport_date_of_expire: this.$store.format_date(
            this.passport_date_of_expire
          ),
          passport_date_of_issue: this.$store.format_date(
            this.passport_date_of_issue
          ),
          country_of_residence: this.country_of_residence,
          city_of_residence: this.city_of_residence,
          address: this.address,
          whatsapp_number: this.whatsapp_number,
          need_visa: this.need_visa
        })
        .then(response => {
          this.$notify({
            message: "User information updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 5000
          });
        });
    }
  },
  mounted() {
    this.$store
      .getCountries()
      .then(response => {
        this.countries = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
  }
};
</script>
<style></style>
